export const setLoginSucceeded = loginSucceeded => {
	return { type: 'SET_LOGIN_SUCCEEDED', loginSucceeded };
};